<template>
    <v-container>
        <div>
            <v-row justify="space-between">
                <v-col cols="12" sm="6" justify="center">
                    <p class="header-title"> {{$t('staff_management.title')}} </p>
                </v-col>

                <v-col cols="12" sm="6">
                    <div class="d-flex flex-row-reverse">
                        <v-btn color="primary" dark @click="createNewStaff">{{ $t('common.create')}}</v-btn>
                        <v-btn color="primary" dark @click="getData" class="mr-5">{{ $t('common.refresh')}}</v-btn>
                    </div>
                </v-col>
            </v-row>
        </div>
        <v-data-table :headers="headers" :items="desserts" :search="search" class="elevation-1" hide-default-footer :page.sync="page" :loading="loading" :items-per-page="itemsPerPage" @page-count="pageCount = $event">
            <template v-slot:top>
                <!-- <div> 
                    <p class="header-title pt-5 pl-5"> {{$t('staff_management.title')}} </p>
                </div> -->
               

                <!-- <v-container align="center"> -->
                <v-toolbar flat color="white" class="pt-5"> 
                    <v-row justify="start">
                        <v-col cols="12" sm="1">
                            <v-autocomplete v-model="itemsPerPage" :items="numberPage" outlined :dense="true"></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="2" v-if="isAdmin || userCategory > 2">
                            <v-autocomplete v-model="selectCategoryFilter" :items="categoriesFilter" item-text="title" v-bind:label="$t('job_management.role')" return-object outlined :dense="true"></v-autocomplete>
                        </v-col>
                        
                        <v-col cols="12" sm="2" v-if="isAdmin">
                            <v-autocomplete v-model="selectBlock" :items="blocks" item-text="name" v-bind:label="$t('department_management.block')" return-object outlined :dense="true"></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="7">
                            <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line hide-details outlined :dense="true"></v-text-field>
                        </v-col>
                    </v-row>
                <!-- </v-container> -->
                </v-toolbar>

            </template>

            <template v-slot:[`item.nickname`]="{ item }">
                <div class="contentAddress">
                    <v-avatar size="30" class="mr-1">
                    <img v-if="item.avatar" :src="baseImage + item.avatar"/>
                    <img v-else src='@/assets/avatar_default.png'/>
                    </v-avatar>

                    <span class="text-no-wrap"> {{ item.nickname }} </span>
                </div>

            </template>

            <template v-slot:[`item.action`]="{ item }">
                <div class="contentTitle">
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                        <template v-slot:activator="{ on }">
                            <v-icon v-on="on" small class="mr-2" @click="showDialogUserInfor(item)">
                            info
                            </v-icon>
                        </template>
                        <span>Thông tin chi tiết</span>
                    </v-tooltip> 

                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                        <template v-slot:activator="{ on }">
                            <v-icon v-on="on" small class="mr-2" @click="editItem(item)">
                            edit
                            </v-icon>
                        </template>
                        <span>Chỉnh sửa thông tin nhân viên</span>
                    </v-tooltip> 
                    
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                        <template v-slot:activator="{ on }">
                            <v-icon v-on="on" small class="mr-2" @click="disableUser(item)">
                            delete
                            </v-icon>
                        </template>
                        <span>Xóa nhân viên</span>
                    </v-tooltip>
                </div>
            </template>

            <template v-slot:[`item.fullname`]="{ item }">
                <span class="text-no-wrap">
                  {{ item.fullname }}
                </span>
            </template>

            <template v-slot:[`item.identify`]="{ item }">
                <span class="text-no-wrap">
                  {{ item.identify }}
                </span>
            </template>

            <template v-slot:[`item.email`]="{ item }">
                <span class="text-no-wrap">
                  {{ item.email }}
                </span>
            </template>

            <template v-slot:[`item.status`]="{ item }">
                <span class="text-no-wrap">
                  {{ getStringByStatus(item.status) }}
                </span>

                <!-- <v-switch :true-value="1" :false-value="0" v-model="item.status" color="primary" v-else>
                </v-switch>  -->
            </template>

            <template v-slot:[`item.joined_date`]="{ item }">
                <span class="text-no-wrap">{{item.joined_date | formateDate}}</span>
            </template>

            <template v-slot:[`item.birthday`]="{ item }">
                <span class="text-no-wrap">{{item.birthday | formateDate}}</span>
            </template>

            <template v-slot:[`item.address`]="{ item }">
                <span class="contentAddress">{{addressToString(item.address)}}</span>
            </template>

            <template v-slot:[`item.job`]="{ item }">
                <span class="contentAddress">{{getJobDisplay(item.job)}}</span>
            </template>

            <!-- <template v-slot:[`item.detail`]="{ item }">
                <v-icon small class="mr-2" @click="showDialogUserInfor(item)">
                    info
                </v-icon>
            </template> -->

            <template v-slot:no-data>
                <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
            </template>
        </v-data-table>

        <div class="text-center pt-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>

        <user-infor-dialog v-model="dialogUserInfor" :editedItem="editedItem" @closeDialog="closeDialogUserInfor"
          v-if="editedItem"> 
        </user-infor-dialog>

        <user-dialog v-model="dialogEditUser" :editedItem="editedItem" :editedIndex="editedIndex" @closeDialog="closeEditUser" @updateUser="updateUser"
          v-if="editedItem"> 
        </user-dialog>
    </v-container>
</template>

<script>
import i18n from '@/plugins/i18n';
import moment from 'moment';
import UserInforDialog from "@/components/UserInforDialog";
import UserDialog from "@/components/UserDialog";

export default {
    data: () => ({
        
        show: false,
        e1 : 0,
        page: 1,
        pageCount: 0,
        itemsPerPage: 10,
        isEdit: false,

        isAdmin: localStorage.getItem('isAdmin') === 'true' ? true : false,
        userCategory: parseInt(localStorage.getItem('category')),

        baseImage: process.env.VUE_APP_BASE_IMAGE,
        baseAttach: process.env.VUE_APP_BASE_ATTACH,
        rating: 5,

        date: '',
        checkbox1: true,
        checkbox2: false,

        loading: true,
        numberPage: [
            5, 10, 15, 20, 25
        ],
        
        modal: false,

        blocks: [],
        selectBlock: null,
        
        firstEdit: true,
        search: '',
        dialog: false,

        headers: [
            { text: '#', align: 'left', sortable: false, value: 'index' },
            { text: i18n.t('profile.nickname'), value: 'nickname', sortable: false},
            { text: i18n.t('profile.fullname'), value: 'fullname', sortable: false},
            { text: i18n.t('profile.email'), value: 'email', sortable: false},
            { text: i18n.t('profile.phone'), value: 'phone', sortable: false },
            { text: i18n.t('job_management.role'), value: 'job', sortable: false },
            // { text: i18n.t('profile.birthday'), value: 'birthday', sortable: false},
            // { text: i18n.t('profile.identify'), value: 'identify', sortable: false},
            // { text: i18n.t('profile.address'), value: 'address', sortable: false},
            // { text: i18n.t('profile.join_date'), value: 'joined_date', sortable: false},
            
            // { text: i18n.t('design_manager.infor'), align: 'center', value: 'detail', sortable: false },
            { text: i18n.t('design_manager.infor'), align: 'center', value: 'action', sortable: false}
        ],
        jobToAdd: [],
        jobs: [],
        desserts: [],
        fullStaff: [],
        editedIndex: -1,
        editedItem: null,
        defaultItem: {},

        categoriesFilter: [],
        selectCategoryFilter: null,

        dialogUserInfor: false,
        dialogEditUser: false,

        stringRules: [
          v => !!v || i18n.t('validate.not_empty'),
        //   v => (v && v.length > 3) || i18n.t('validate.string_invalid')
        ],
        identifyRules: [
          v => (v && v.length > 8) || i18n.t('validate.indentify_invalid')
        ],
        phoneRules: [
            v => !!v || i18n.t('validate.not_empty'),
            v => (v && v.length > 9) || i18n.t('validate.phone_invalid'),
        ],
        addressRules: [
            v => !!v || i18n.t('validate.not_empty'),
            // v => (v && v.length > 5) || i18n.t('validate.address_invalid'),
        ],
        emailRules: [
            v => !!v || i18n.t('validate.email_require'),
            v => /.+@.+\..+/.test(v) || i18n.t('validate.email_invalid'),
        ],
        passdRules: [
            v => !!v || i18n.t('validate.password_require'),
            v => (v && v.length > 5) || i18n.t('validate.password_invalid'),
        ]
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? i18n.t('staff_management.add_management') : i18n.t('staff_management.edit_management')
        },

        computedDateFormatted () {
            return this.formatDate(this.date)
        },
    },

    components: {
        UserInforDialog: UserInforDialog,
        UserDialog: UserDialog
    },

    watch: {
        selectCategoryFilter() {
            this.filterData();
        },

        selectBlock() {
            this.filterData();
        }
    },

    async created() {
        await this.getBlock();
        await this.getData();
        await this.getAllCategory();
    },

    async mounted() {
      
    },

    methods: {
        initialize() {
        },

        formatDate (date) {
            if (!date) {
                return null
            }
            
            const [year, month, day] = date.split('-')
            return `${month}/${day}/${year}`
        },

        closeDialogUserInfor(value) {
            this.dialogUserInfor = value
            this.editedItem = null;
        },

        closeEditUser(value) {
            this.dialogEditUser = value,
            this.editedItem = null;
        },

        updateUser(value) {
            if (this.editedIndex > -1) {
                Object.assign(this.desserts[this.editedIndex], value);
            } else {
                this.getData();
            }
        },

        back () {
            if (this.e1 > 1) {
                this.e1 = this.e1 - 1;
            }
        },

        selectJob(job) {
            this.selectedJob = job;
        },

        editItem(item) {
            this.editedIndex = this.desserts.indexOf(item);
            this.editedItem = Object.assign({}, item);

            this.dialogEditUser = true;
        },

        createNewStaff() {
            this.editedIndex = -1;
            this.editedItem = {};

            this.dialogEditUser = true;
        },

        async disableUser(item) {
            const agree = confirm(i18n.t('common.confirm_disable_user'))
            if (agree) {
                const self = this;
                const requestBody = {
                    status: 0
                }
                try {
                    const response = await this.$http.put(process.env.VUE_APP_STATUS_USER_API + item._id, requestBody);

                    if (response.data && response.data.success) {
                        this.$fire({
                            title: i18n.t('common.delete_user_success'),
                            text: "",
                            type: "success"
                            }).then(() => {
                                self.getData();
                        });
                    }
                } catch (e) {
                    console.log(e.stack);
                }
            }
        },

        showDialogUserInfor(item) {
            this.editedItem = Object.assign({}, item);            
            this.dialogUserInfor = true;
        },

        async getData() {
            const userId = localStorage.getItem("user_id");
            this.loading = true;
            try {
                const response = await this.$http.get(process.env.VUE_APP_GET_USER_CONTEXT_URL + '?status=1');
                if (response.data && response.data.success) {
                    // console.log(response.data);
                    const contextArr = response.data.data;
                    contextArr.forEach((item, index) => item.index = index + 1);
                    
                    this.fullStaff = contextArr.filter(item => item._id !== userId);
                    this.desserts = contextArr;

                    this.loading = false;
                }
            } catch (e) {
                console.log(e.stack);
            }
        },

        addressToString(address) {
            if (address && address.fullDetail) {
                return address.fullDetail;
            } else {
                return '';
            }
        },

        async getAllCategory() {
            try {
                const response =  await this.$http.get('/job/categories/0');
                if(response.data && response.data.success) {
                    this.categories = response.data.data;

                    if (!this.isAdmin) {
                        this.categories = this.categories.filter(item => item.type < this.userCategory);
                    }

                    const optionAll = {
                        title : "Tất cả",
                        _id : "-1"
                    }

                    this.categoriesFilter = [optionAll].concat(this.categories);
                    this.selectCategoryFilter = optionAll;
                }
            } catch(e) {
                console.log(e.stack);
            }
        },

        getJobDisplay(job) {
            if (!job) {
                return '';
            }

            return job.title;
        },

        dateToDisplay(date) {
            return moment(date).format("MM/DD/YYYY");
        },

        async getBlock() {
            try {
                const response = await this.$http.get(process.env.VUE_APP_GET_BLOCK_URL);
                if (response.data && response.data.success) {
                    const optionAll = {
                        name : "Tất cả",
                        _id : "-1"
                    }

                    this.blocks = [optionAll].concat(response.data.data);
                    this.selectBlock = optionAll;
                }
            } catch (e) {
                console.log(e.stack);
            }
        },

        getStringByStatus(status) {
            if (status == 1) {
                return i18n.t('profile.active')
            } else if (status == 2) {
                return i18n.t('profile.waiting_approve');
            } else {
                return i18n.t('profile.inactive')
            }
        },

        filterData() {
            if (!this.fullStaff || this.fullStaff.length == 0) {
                return;
            }

            this.desserts = [].concat(this.fullStaff);
            let dataArray = [];

            if (this.selectCategoryFilter && this.selectCategoryFilter._id != -1) {
                this.fullStaff.forEach(item => {
                    const job = item.job;
                    if (job && job.category._id == this.selectCategoryFilter._id) {
                        dataArray.push(item);
                    }
                })

                this.desserts = [].concat(dataArray);
            }
            
            let tempDataArray = [];
            if (this.selectBlock && this.selectBlock._id != -1) {
                this.desserts.forEach(item => {
                    const job = item.job;
                    if (job.context) {
                        if (job.context.parents && job.context.parents.length > 0) {
                            const context = job.context.parents.find(parent => parent._id == this.selectBlock._id);
                            if (context) {
                                tempDataArray.push(item);
                            }
                        } else {
                            if (job.context._id == this.selectBlock._id) {
                                tempDataArray.push(item);
                            }
                        }
                    }
                })

                this.desserts = [].concat(tempDataArray);
            }
        }
    },
}
</script>

<style scoped>

  .v-text-field .v-input__control .v-input__slot {
    min-height: 45px !important;
    /* display: flex !important; */
    align-items: center !important;
  }
</style>
